const getUniqueIncentives = (incentives) => {
  const safeIncentives = Array.isArray(incentives) ? incentives : [];
  return Array.from(
    safeIncentives
      .reduce((map, item) => {
        map.set(item.id, item);
        return map;
      }, new Map())
      .values()
  );
};

export default getUniqueIncentives;